export default "__VITE_ASSET__BEMS_0Y3__"